
const interceptor = (ax) => {
  ax.interceptors.request.use(
    (config) => {
      const isFormData = config.data instanceof FormData;
      const token = localStorage.getItem("authToken");
      config.headers = {
        ...config.headers,
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
        Authorization: token ? `Bearer ${token}` : "",
      };

      return config;
    },
    (error) => {
      console.error('Request error:', error);
      return Promise.reject(error);
    }
  );

  ax.interceptors.response.use(
    (next) => {
      return Promise.resolve(next);
    },
    (error) => {
      if (error?.response && error?.response?.status === 401) {
        localStorage.removeItem("authToken"); // Clear the token
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};

export { interceptor };
